import { useEffect, useState } from 'react';
import { getBffNotificationUrl } from '../../util/getBffUrl';
import { EventSourcePolyfill } from 'event-source-polyfill';
import {SSEEventListener} from './SSEEventListener';
import { getDefaultStore } from '../Home/Home';
import { v4 as uuidv4 } from 'uuid';

export const useSSE = (token:string,userProfile:any,handler:Function) => {

  const sseClient = SSEEventListener();
  const [connected, setConnected] = useState(false);
  const store = getDefaultStore(userProfile);
  
  useEffect(() => {
    if (token) {
      const toBearerAuth = (token: string) => `Bearer ${token}`;

      const enterpriseId = userProfile?.fullUser?.enterprise?.id || "";
      const storeId = store?.id || "";
      const uid = uuidv4();
      const params = new URLSearchParams({
        enterpriseId,
        storeId,
        uid,
      });
      const url = `${getBffNotificationUrl()}/stream?${params.toString()}`;

      let eventSource = new EventSourcePolyfill(url, {
        headers: { Authorization: toBearerAuth(token) },
        withCredentials: false,
      });
      sseClient.connect(eventSource, handler);
      setConnected(true);
      return () => {
        sseClient.close();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return connected;
}
